module.exports = __webpack_public_path__ + "static/img/Beats_X.3eeaec9c.jpg";